import createPropType from "./createResponsivePropType";

const verticalAlignPropType = createPropType(["wrap", "nowrap"]);

export default verticalAlignPropType;
